import { createContext, useContext, useMemo, useState, type FC, type ReactNode } from "react";
import Logout from "../components/login/Logout";

type LogoutModalContextValue = {
  isOpen: boolean;
  openLogoutModal: () => void;
  closeLogoutModal: () => void;
};

const LogoutModalContext = createContext<LogoutModalContextValue | null>(null);

export const LogoutModalProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openLogoutModal = () => setIsOpen(true);
  const closeLogoutModal = () => setIsOpen(false);

  const value = useMemo(
    () => ({
      isOpen,
      openLogoutModal,
      closeLogoutModal,
    }),
    [isOpen],
  );

  return (
    <LogoutModalContext.Provider value={value}>
      {children}
      {isOpen && <Logout closeModal={closeLogoutModal} />}
    </LogoutModalContext.Provider>
  );
};

export const useLogoutModal = () => {
  const ctx = useContext(LogoutModalContext);
  if (ctx === null) {
    throw new Error("useLogoutModal doit être utilisé dans un LogoutModalProvider");
  }
  return ctx;
};

